export default __webpack_public_path__ + "static/media/phoneLogo.5e9e1901.svg";